<template>
    <div class="media align-items-center">
        <span class="avatar avatar-sm rounded-circle">
            <img alt="profile" :src="image(user.photo)" />
        </span>
        <div
            v-if="gamificationRules.show_student_name"
            class="ml-3 d-lg-block gamification-div-name"
        >
            <span
                class="mb-0 gamification-name"
                :alt="user.name"
            >{{ user.name }}</span>
        </div>
    </div>
</template>

<script>

export default {
    name: 'GamificationProfile',
    data() {
        return {
            isOpen: false,
            isShow: false,
        };
    },
    props: {
        gamificationRules: Object,
        user: {
            type: Object,
        },
    },
    mounted() {
        this.$store.commit('SET_USER_PHOTO', this.image(this.user.photo));
        if (this.user.student && this.user.student.student) {
            this.$store.commit('SET_STUDENT', this.user.student.student);
        }
    },
    methods: {
        image(image, size = 'thumb') {
            if (!image) return '/img/profile.png';
            if (image.urls && image.urls[size]) return image.urls[size];
            return `/storage/${image.host}/${size}/${image.original_file}`;
        },
    },
};
</script>

<style>
.nch--nav-link {
    color: #525f7f !important;
}
.gamification-name {
    font-size: 20px;
    font-weight: 400;
}
.gamification-div-name {
    width: 140.47px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
@media (max-width: 372px) {
    .gamification-name {
        font-size: 15px;
    }
    .gamification-div-name {
        width: 70px;
        margin-left: 8px !important;
        font-size: 15px;
    }
}
@media (min-width: 373px) and (max-width: 424px) {
    .gamification-name {
        font-size: 15px;
    }
    .gamification-div-name {
        width: 100.47px;
        margin-left: 8px !important;
        font-size: 15px;
    }
}
</style>
